import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Globe } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';
import { ASSETS } from '../data/content';

const COLS = [
    {
        titleKey: 'footer.col_explore',
        links: [
            { labelKey: 'nav.about', to: '/about' },
            { labelKey: 'nav.history', to: '/history' },
            { labelKey: 'nav.leadership', to: '/leadership' },
            { labelKey: 'nav.capabilities', to: '/capabilities' },
            { labelKey: 'nav.strategy', to: '/strategy' },
        ],
    },
    {
        titleKey: 'footer.col_portfolio',
        links: [
            { labelKey: 'nav.projects', to: '/projects' },
            { labelKey: 'nav.global', to: '/global-presence' },
            { labelKey: 'nav.partnerships', to: '/partnerships' },
            { labelKey: 'nav.contact', to: '/contact' },
        ],
    },
];

export const Footer = () => {
    const { t } = useLang();
    return (
        <footer data-testid="site-footer" className="bg-navy-deep text-white border-t border-gold/15">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <div className="mb-6">
                            <img
                                src={ASSETS.logo}
                                alt="Delta International Energy"
                                className="h-16 w-auto object-contain"
                            />
                        </div>
                        <p className="text-white/65 text-sm leading-relaxed max-w-md">
                            {t('footer.about_blurb')}
                        </p>
                        <div className="hairline-gold w-24 my-8" />
                        <p className="eyebrow text-gold mb-3">{t('footer.headquarters')}</p>
                        <p className="text-white/80 text-sm leading-relaxed">
                            {t('footer.address')}
                        </p>
                    </div>

                    {COLS.map((col) => (
                        <div className="md:col-span-2" key={col.titleKey}>
                            <p className="eyebrow text-gold mb-5">{t(col.titleKey)}</p>
                            <ul className="space-y-3">
                                {col.links.map((l) => (
                                    <li key={l.to}>
                                        <Link to={l.to} data-testid={`footer-link-${l.to.replace(/\//g, '')}`} className="text-white/70 hover:text-gold text-sm transition-colors">
                                            {t(l.labelKey)}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    <div className="md:col-span-3">
                        <p className="eyebrow text-gold mb-5">{t('nav.contact')}</p>
                        <ul className="space-y-4 text-sm text-white/70">
                            <li className="flex items-start gap-3">
                                <Phone className="w-4 h-4 mt-1 text-gold flex-shrink-0" />
                                <div>
                                    <div>+966 12 422 4097</div>
                                </div>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail className="w-4 h-4 mt-1 text-gold flex-shrink-0" />
                                <a href="mailto:info@deltagroup-intl.com" className="hover:text-gold">info@saudideltaenergy.com / info@deltagroup-intl.com</a>
                            </li>
                            <li className="flex items-start gap-3">
                                <Globe className="w-4 h-4 mt-1 text-gold flex-shrink-0" />
                                <span>www.saudideltaenergy.com</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin className="w-4 h-4 mt-1 text-gold flex-shrink-0" />
                                <span>{t('footer.jeddah_sa')}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <p className="text-white/50 text-xs tracking-wide">
                        © {new Date().getFullYear()} Delta International Group Ltd. {t('footer.rights')}
                    </p>
                    <p className="text-gold/80 text-[10px] tracking-[0.3em] uppercase">
                        {t('footer.tagline')}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
